import { createContext, useContext, useMemo } from 'react'

const FilterMenuScrollBehaviorContext = createContext({ closeOnPageScroll: true, pullLeft: undefined })

export const FilterMenuScrollBehaviorProvider = ({ closeOnPageScroll, pullLeft, children }) => {
  const value = useMemo(
    () => ({ closeOnPageScroll: closeOnPageScroll ?? true, pullLeft }),
    [closeOnPageScroll, pullLeft],
  )
  return (
    <FilterMenuScrollBehaviorContext.Provider value={value}>
      {children}
    </FilterMenuScrollBehaviorContext.Provider>
  )
}

export const useFilterMenuScrollBehavior = () => useContext(FilterMenuScrollBehaviorContext)
